import {
  IPlatformResourcesResponse,
  IPlatformResourceResponse,
  IPlatformStage,
  IPlatformStagePayload
} from 'types/platformResources';
import request from './index';

export const getPlatformStages = (practiceId: number) =>
  request<IPlatformResourcesResponse<IPlatformStage>>({
    options: {
      url: `/platform/resources/practices/${practiceId}/stages`,
      method: 'get'
    }
  });

export const createPlatformStage = (practiceId: number, data: IPlatformStagePayload) =>
  request<IPlatformResourceResponse<IPlatformStage>>({
    options: {
      url: `/platform/resources/practices/${practiceId}/stages`,
      method: 'post',
      data
    }
  });

export const editPlatformStage = (id: number, data: IPlatformStagePayload) =>
  request<IPlatformResourceResponse<IPlatformStage>>({
    options: { url: `/platform/resources/stages/${id}`, method: 'patch', data }
  });

export const deletePlatformStage = (id: number) =>
  request<Record<string, never>>({
    options: { url: `/platform/resources/stages/${id}`, method: 'delete' }
  });
